module.exports = __webpack_public_path__ + "static/media/ui.c7724050.png";